export const cleanerLevels = {
  ASP: 'ASP',
  ASC: 'ASC',
  ASCS: 'ASCS',
  AQS1: 'AQS1',
  AQS2: 'AQS2',
  AQS3: 'AQS3',
  ATQS1: 'ATQS1',
  ATQS2: 'ATQS2',
  ATQS3: 'ATQS3',
  CE1: 'CE1',
  CE2: 'CE2',
  CE3: 'CE3',
  MP1: 'MP1',
  MP2: 'MP2',
  MP3: 'MP3',
  MP4: 'MP4',
  MP5: 'MP5',
};

export const minHourlyRate = {
  [cleanerLevels.ASP]: {
    A: 12.52,
    B: 12.71,
  },
  [cleanerLevels.ASC]: {
    A: 12.57,
    B: 12.79,
  },
  [cleanerLevels.ASCS]: {
    A: 12.64,
    B: 12.86,
  },
  [cleanerLevels.AQS1]: {
    A: 12.70,
    B: 12.91,
  },
  [cleanerLevels.AQS2]: {
    A: 12.81,
    B: 13.05,
  },
  [cleanerLevels.AQS3]: {
    A: 12.92,
    B: 13.16,
  },
  [cleanerLevels.ATQS1]: {
    A: 13.17,
    B: 13.39,
  },
  [cleanerLevels.ATQS2]: {
    A: 13.91,
    B: 14.16,
  },
  [cleanerLevels.ATQS3]: {
    A: 14.95,
    B: 15.27,
  },
  [cleanerLevels.CE1]: 14.43,
  [cleanerLevels.CE2]: 15.27,
  [cleanerLevels.CE3]: 15.44,
  [cleanerLevels.MP1]: 15.52,
  [cleanerLevels.MP2]: 16.39,
  [cleanerLevels.MP3]: 18.18,
  [cleanerLevels.MP4]: 20.25,
  [cleanerLevels.MP5]: 21.90
};

export const isCleaner = (func) => {
  if (!func) {
    return false;
  }
  if (
    func === 'Cleaner' ||
    func === 'Glazier' ||
    func === 'Handyman' ||
    func === 'Team Leader'
  ) {
    return true;
  }
  return false;
};

export const isTeamLeader = (level) => {
  switch (level) {
    case 'CE1':
    case 'CE2':
    case 'CE3':
      return true;
    default:
      return false;
  }
};

export const computeMinRate = (level, classification) => {
  return isTeamLeader(level)
    ? minHourlyRate[level]
    : minHourlyRate[level][classification];
};
